import { render, staticRenderFns } from "./price-importer-page.vue?vue&type=template&id=5dce4f1e&"
import script from "./price-importer-page.vue?vue&type=script&lang=js&"
export * from "./price-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports